import { CompanyLinkType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const TRANS_KEY = 'COMPANY_LINKS.EDIT_FREELANCER_FORM.FORM_SCHEMA';

const formSchema = z.object({
  contact: z.object({
    phone: z.string({
      message: t(`personDetailsGeneral:${TRANS_KEY}.PHONE_REQUIRED`),
    }),
    mobile: z.string({
      message: t(`personDetailsGeneral:${TRANS_KEY}.MOBILE_REQUIRED`),
    }),
    email: z
      .string()
      .trim()
      .email({
        message: t(`personDetailsGeneral:${TRANS_KEY}.EMAIL_INVALID`),
      })
      .or(z.literal('')),
  }),
  address: z.object({
    street: z.string({
      message: t(`personDetailsGeneral:${TRANS_KEY}.STREET_REQUIRED`),
    }),
    addition: z.string(),
    zip: z.string({
      message: t(`personDetailsGeneral:${TRANS_KEY}.ZIP_REQUIRED`),
    }),
    city: z.string({
      message: t(`personDetailsGeneral:${TRANS_KEY}.CITY_REQUIRED`),
    }),
    country: z.string({
      message: t(`personDetailsGeneral:${TRANS_KEY}.COUNTRY_REQUIRED`),
    }),
  }),
  categories: z.array(z.string()),
});

export type FreelancerFormSchemaType = z.infer<typeof formSchema>;

type UseFreelancerFormReturnType = UseFormReturn<FreelancerFormSchemaType>;

export const useFreelancerForm = (
  freelancer?: CompanyLinkType
): UseFreelancerFormReturnType => {
  return useForm({
    defaultValues: {
      contact: {
        phone: freelancer?.contact.phone ?? '',
        mobile: freelancer?.contact.mobile ?? '',
        email: freelancer?.contact.email ?? '',
      },
      address: {
        street: freelancer?.address.street ?? '',
        addition: freelancer?.address.addition ?? '',
        zip: freelancer?.address.zip ?? '',
        city: freelancer?.address.city ?? '',
        country: freelancer?.address.country ?? '',
      },
      categories: freelancer?.categories ?? [],
    },
    resolver: zodResolver(formSchema),
  });
};
